export default __webpack_public_path__ + "static/128-59e853d736186a6ab4337ac74ec1b841.jpg";